'use client';

import { useMemo } from "react";
import { ICreatorOptions } from "survey-creator-core";
import { SurveyCreator, SurveyCreatorComponent } from "survey-creator-react";
import "survey-core/survey-core.css";
import "survey-creator-core/survey-creator-core.css";
import "ace-builds/src-noconflict/ace";
import "ace-builds/src-noconflict/ext-searchbox";

const defaultCreatorOptions: ICreatorOptions = {
  showTranslationTab: false,
  showPreviewTab: false,
};

export default function FormBuilder(props: { json?: Record<string, unknown>; options?: ICreatorOptions }) {
  const creator = useMemo(() => {
    const c = new SurveyCreator(props.options || defaultCreatorOptions);
    c.JSON = props.json || {};

    c.saveSurveyFunc = (saveNo: number, callback: (num: number, status: boolean) => void) => {
      const surveyJson = JSON.stringify(creator.JSON, null, 2);

      // Cria o blob para o JSON
      const blob = new Blob([surveyJson], { type: "application/json" });

      // Gera URL temporária
      const url = URL.createObjectURL(blob);

      // Cria link para download
      const a = document.createElement("a");
      a.href = url;
      a.download = `survey-${new Date().toISOString().replace(/[:.]/g, "-")}.json`;
      a.style.display = "none";
      document.body.appendChild(a);

      // Dispara o download
      a.click();

      // Limpa elementos temporários
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      callback(saveNo, true);
    };

    return c;
  }, [props.json, props.options]);

  return (
    <div style={{ height: "100vh", width: "100%" }}>
      <SurveyCreatorComponent creator={creator} />
    </div>
  );
}
